// ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children }) => {
  const { passwordResetSuccess } = useAuth();

  if (!passwordResetSuccess) {
    return <Navigate to="/" />;
  }

  return children;
};


export default ProtectedRoute;
